const AuthenticationTypes = {
    BearerToken: 'Bearer',
    SocialToken: 'Social',
};

export default AuthenticationTypes;